import { render } from "./Bonus.vue?vue&type=template&id=55b69ab7"
import script from "./Bonus.vue?vue&type=script&lang=js"
export * from "./Bonus.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/frontdash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__